import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { TimeFormats } from '@app/advisor-content-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const mandatoryProps_TimeFormats = {
    adapter: SimpleListAdapter([...TimeFormats], item => _jsx(_Fragment, { children: item.item })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Select Time Format'
};
export const DropDown_TimeFormats = TS_DropDown.prepare(mandatoryProps_TimeFormats);
//# sourceMappingURL=ui-components.js.map